<template>
  <div class="brand-collect">
    <div class="wrap pcWrap">
      <div class="body">
        <div class="topBox">
          <div class="innerBox">
            <div class="leftBox">
              <div class="title1">{{ translateTitle("参与4EAMA") }}</div>
              <div class="title2">{{ translateTitle("聆听行业洞见") }}</div>
              <div class="text">{{ translateTitle("视野领先全球") }}</div>
              <div class="btns">
                <div class="btn" @click="goBackUrl">
                  <span>{{ translateTitle("查看回放") }}</span>
                </div>
                <img
                  src="../../assets/img/home/brandCollect/img/dark_top_icon1.png"
                  alt=""
                  class="icon"
                  v-if="isdark"
                  @click="goPage('https://x.com/4E_Global')"
                />
                <img
                  src="../../assets/img/home/brandCollect/img/top_icon1.png"
                  alt=""
                  class="icon"
                  v-else
                  @click="goPage('https://x.com/4E_Global')"
                />
                <img
                  src="../../assets/img/home/brandCollect/img/dark_top_icon2.png"
                  alt=""
                  class="icon"
                  v-if="isdark"
                  @click="goPage('https://t.me/Official_4e')"
                />
                <img
                  src="../../assets/img/home/brandCollect/img/top_icon2.png"
                  alt=""
                  class="icon"
                  v-else
                  @click="goPage('https://t.me/Official_4e')"
                />
              </div>
            </div>
            <div class="rightBox">
              <div class="swiper">
                <div class="swiper-wrapper">
                  <div
                    class="swiper-slide"
                    @click.stop="
                      goPage(
                        'https://x.com/Click_Web3/status/1882414435417067529'
                      )
                    "
                  >
                    <img
                      src="../../assets/img/home/brandCollect/img/top_banner1.png"
                      alt=""
                    />
                  </div>
                  <div
                    class="swiper-slide"
                    @click.stop="
                      goPage(
                        'https://x.com/4E_Global/status/1894705183101169954'
                      )
                    "
                  >
                    <img
                      src="../../assets/img/home/brandCollect/img/top_banner2.png"
                      alt=""
                    />
                  </div>
                  <div
                    class="swiper-slide"
                    @click.stop="
                      goPage(
                        'https://x.com/4E_Global/status/1903795801635356894'
                      )
                    "
                  >
                    <img
                      src="../../assets/img/home/brandCollect/img/top_banner3.png"
                      alt=""
                    />
                  </div>
                  <div
                    class="swiper-slide"
                    @click.stop="
                      goPage(
                        'https://x.com/4echinese/status/1901573749000020388?s=46'
                      )
                    "
                  >
                    <img
                      src="../../assets/img/home/brandCollect/img/top_banner4.png"
                      alt=""
                    />
                  </div>
                </div>
              </div>
              <div class="others">
                <div class="history">{{ translateTitle("往期回顾") }}</div>
                <div class="btns">
                  <img
                    src="../../assets/img/home/brandCollect/img/dark_arrow_left.png"
                    alt=""
                    class="leftIcon"
                    v-if="isdark"
                    @click="goPre"
                  />
                  <img
                    src="../../assets/img/home/brandCollect/img/arrow_left.png"
                    alt=""
                    class="leftIcon"
                    v-else
                    @click="goPre"
                  />
                  <span>{{ bannerNum }}</span>
                  <img
                    src="../../assets/img/home/brandCollect/img/dark_arrow_right.png"
                    alt=""
                    class="rightIcon"
                    v-if="isdark"
                    @click="goNext"
                  />
                  <img
                    src="../../assets/img/home/brandCollect/img/arrow_right.png"
                    alt=""
                    class="rightIcon"
                    v-else
                    @click="goNext"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="box1">
          <div class="innerBox">
            <div class="title">
              {{ translateTitle("要交易")
              }}<span style="margin-left: 10px">{{
                translateTitle("上4E！")
              }}</span>
            </div>
            <div class="subTitle">
              {{ translateTitle("一站式投资全球热门资产，2024成绩单") }}
            </div>
            <div class="list">
              <div class="item">
                <div class="text1">{{ translateTitle("用户数飞增") }}</div>
                <div class="text2">
                  100<i>{{ translateTitle("万") }}</i>
                </div>
                <div class="text3">{{ translateTitle("交易人数") }}</div>
              </div>
              <div class="item">
                <div class="text1">{{ translateTitle("东南亚臻选") }}</div>
                <div class="text2">41<i>%</i></div>
                <div class="text3">{{ translateTitle("地区客户增速") }}</div>
              </div>
              <div class="item">
                <div class="text1">{{ translateTitle("活跃度超高") }}</div>
                <div class="text2">50<i>%</i></div>
                <div class="text3">
                  {{ translateTitle("社媒互动与交易赛用户占比") }}
                </div>
              </div>
              <div class="item">
                <div class="text1">{{ translateTitle("多资产配置") }}</div>
                <div class="text2">73<i>%</i></div>
                <div class="text3">
                  {{ translateTitle("灵活交易丰富配置用户占比") }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="box2">
          <div class="titleBox">
            <img
              src="../../assets/img/home/brandCollect/img/dark_left_tag.png"
              alt=""
              class="titleTag"
              v-if="isdark"
            />
            <img
              src="../../assets/img/home/brandCollect/img/left_tag.png"
              alt=""
              class="titleTag"
              v-else
            />
            <span
              >{{ translateTitle("精彩")
              }}<i class="xianchang">{{ translateTitle("现场_") }}</i></span
            >
            <img
              src="../../assets/img/home/brandCollect/img/dark_right_tag.png"
              alt=""
              class="titleTag"
              v-if="isdark"
            />
            <img
              src="../../assets/img/home/brandCollect/img/right_tag.png"
              alt=""
              class="titleTag"
              v-else
            />
          </div>
          <div class="contentBox">
            <div class="item item1">
              <div class="textBox">
                <!-- <img src="../../assets/img/home/brandCollect/img/dark_box2_tag1.png" alt="" class="icon" v-if="isdark">
                  <img src="../../assets/img/home/brandCollect/img/box2_tag1.png" alt="" class="icon" v-else> -->
                <div class="icon">
                  <div class="icon-img" :style="{ background: isdark ? 'rgba(255, 255, 255, 0.07)' : 'rgba(51, 72, 246, 0.07)' }">
                    <svg v-if="isdark" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                      <path d="M3.75 16.5003H2.25V1.8753C2.24995 1.8187 2.26272 1.76282 2.28735 1.71185C2.31198 1.66088 2.34782 1.61615 2.3922 1.58101C2.43658 1.54587 2.48833 1.52123 2.54359 1.50894C2.59884 1.49666 2.65616 1.49703 2.71125 1.51005C2.74589 1.50369 2.78104 1.50055 2.81625 1.50068L15.0191 1.52843C15.5006 1.52955 15.7785 1.97093 15.5655 2.40593L13.1265 7.38143C13.0868 7.46243 13.0868 7.64018 13.1258 7.71893L15.5648 12.6416C15.78 13.0758 15.5017 13.5161 15.018 13.5153L3.75 13.5007V16.5003Z" fill="url(#paint0_linear_283_4575)"/>
                      <defs>
                        <linearGradient id="paint0_linear_283_4575" x1="9.31303" y1="6.61411" x2="8.76603" y2="16.4904" gradientUnits="userSpaceOnUse">
                          <stop stop-color="white"/>
                          <stop offset="1" stop-color="#9DA7FA"/>
                        </linearGradient>
                      </defs>
                    </svg>
                    <svg v-else xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                      <path d="M3.75 16.5003H2.25V1.8753C2.24995 1.8187 2.26272 1.76282 2.28735 1.71185C2.31198 1.66088 2.34782 1.61615 2.3922 1.58101C2.43658 1.54587 2.48833 1.52123 2.54359 1.50894C2.59884 1.49666 2.65616 1.49703 2.71125 1.51005C2.74589 1.50369 2.78104 1.50055 2.81625 1.50068L15.0191 1.52843C15.5006 1.52955 15.7785 1.97093 15.5655 2.40593L13.1265 7.38143C13.0868 7.46243 13.0868 7.64018 13.1258 7.71893L15.5648 12.6416C15.78 13.0758 15.5017 13.5161 15.018 13.5153L3.75 13.5007V16.5003Z" fill="#3348F6"/>
                    </svg>
                  </div>
                  <div class="icon-text">
                    <span>{{ translateTitle("越南活动") }}</span>
                  </div>
                </div>

                <div class="text">
                  {{ translateTitle("4E越南峰会：") }}<br />{{
                    translateTitle("FINE-TUNE YOUR FORTUNE")
                  }}
                </div>
                <div class="tips">
                  {{ translateTitle("足球传奇贝隆出席助阵") }}
                </div>
              </div>
              <img
                src="../../assets/img/home/brandCollect/img/box2_img11.png"
                class="img"
                alt=""
              />
            </div>
            <div class="item item2">
              <img
                src="../../assets/img/home/brandCollect/img/box2_img2.png"
                class="img"
                alt=""
              />
              <div class="textBox text-box-2">
                <!-- <img src="../../assets/img/home/brandCollect/img/dark_box2_tag2.png" alt="" class="icon" v-if="isdark">
                  <img src="../../assets/img/home/brandCollect/img/box2_tag2.png" alt="" class="icon" v-else> -->
                <div class="icon">
                  <img
                    src="../../assets/img/home/brandCollect/img/dark_box2_icon2.png"
                    alt=""
                    class="icon-img"
                    v-if="isdark"
                  />
                  <img
                    src="../../assets/img/home/brandCollect/img/box2_icon2.png"
                    alt=""
                    class="icon-img"
                    v-else
                  />
                  <div class="icon-text">
                    <span>{{ translateTitle("铂金赞助商") }}</span>
                  </div>
                </div>
                <div class="text">
                  Token2049<br />{{ translateTitle("铂金赞助商") }}
                </div>
                <div class="tips">
                  {{ translateTitle("让行业听到4E的声音") }}
                </div>
              </div>
            </div>
            <div class="item item1">
              <div class="textBox">
                <!-- <img src="../../assets/img/home/brandCollect/img/dark_box2_tag3.png" alt="" class="icon" v-if="isdark">
                  <img src="../../assets/img/home/brandCollect/img/box2_tag3.png" alt="" class="icon" v-else> -->
                <div class="icon">
                  <div class="icon-img" :style="{ background: isdark ? 'rgba(255, 255, 255, 0.07)' : 'rgba(51, 72, 246, 0.07)' }">
                    <svg v-if="isdark" xmlns="http://www.w3.org/2000/svg" width="16" height="13" viewBox="0 0 16 13" fill="none">
                      <path d="M3.15168 6.44602e-09H12.6544C12.7595 -1.46204e-05 12.8632 0.0248636 12.957 0.0726011C13.0507 0.120339 13.1318 0.18958 13.1937 0.274667L15.7417 3.77867C15.787 3.84101 15.8093 3.91714 15.8048 3.99408C15.8003 4.07102 15.7693 4.14402 15.717 4.20067L8.14768 12.4007C8.11647 12.4345 8.07859 12.4615 8.03642 12.48C7.99425 12.4984 7.94872 12.508 7.90268 12.508C7.85665 12.508 7.81112 12.4984 7.76895 12.48C7.72678 12.4615 7.6889 12.4345 7.65768 12.4007L0.0883505 4.20133C0.0360862 4.14469 0.00506559 4.07168 0.000568263 3.99474C-0.00392907 3.9178 0.0183748 3.84168 0.0636838 3.77933L2.61235 0.275333C2.6742 0.190247 2.75531 0.121005 2.84905 0.0732677C2.94279 0.0255302 3.04649 0.000651996 3.15168 0.000666625V6.44602e-09Z" fill="url(#paint0_linear_283_4420)"/>
                      <defs>
                        <linearGradient id="paint0_linear_283_4420" x1="8.33805" y1="4.26439" x2="8.01538" y2="12.5124" gradientUnits="userSpaceOnUse">
                          <stop stop-color="white"/>
                          <stop offset="1" stop-color="#9DA7FA"/>
                        </linearGradient>
                      </defs>
                    </svg>
                    <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="13" viewBox="0 0 16 13" fill="none">
                      <path d="M3.15168 6.44602e-09H12.6544C12.7595 -1.46204e-05 12.8632 0.0248636 12.957 0.0726011C13.0507 0.120339 13.1318 0.18958 13.1937 0.274667L15.7417 3.77867C15.787 3.84101 15.8093 3.91714 15.8048 3.99408C15.8003 4.07102 15.7693 4.14402 15.717 4.20067L8.14768 12.4007C8.11647 12.4345 8.07859 12.4615 8.03642 12.48C7.99425 12.4984 7.94872 12.508 7.90268 12.508C7.85665 12.508 7.81112 12.4984 7.76895 12.48C7.72678 12.4615 7.6889 12.4345 7.65768 12.4007L0.0883505 4.20133C0.0360862 4.14469 0.00506559 4.07168 0.000568263 3.99474C-0.00392907 3.9178 0.0183748 3.84168 0.0636838 3.77933L2.61235 0.275333C2.6742 0.190247 2.75531 0.121005 2.84905 0.0732677C2.94279 0.0255302 3.04649 0.000651996 3.15168 0.000666625V6.44602e-09Z" fill="url(#paint0_linear_283_4021)"/>
                      <defs>
                        <linearGradient id="paint0_linear_283_4021" x1="8.33805" y1="4.26439" x2="8.01538" y2="12.5124" gradientUnits="userSpaceOnUse">
                          <stop stop-color="#3348F6"/>
                          <stop offset="1" stop-color="#9DA7FA"/>
                        </linearGradient>
                      </defs>
                    </svg>
                  </div>
                  <div class="icon-text">
                    <span>{{ translateTitle("泰国活动") }}</span>
                  </div>
                </div>
                <div class="text">
                  {{ translateTitle("4E泰国峰会") }}<br />{{
                    translateTitle("圆满落幕")
                  }}
                </div>
                <div class="tips">
                  {{ translateTitle("百余位东南亚KOL齐聚参与") }}
                </div>
              </div>
              <img
                src="../../assets/img/home/brandCollect/img/box2_img3.png"
                class="img"
                alt=""
              />
            </div>
          </div>
        </div>
        <div class="box3">
          <div class="innerBox">
            <div class="leftBox">
              <div class="item1 item">
                <img
                  src="../../assets/img/home/brandCollect/img/dark_box3_icon1.png"
                  alt=""
                  class="icon"
                  v-if="isdark"
                />
                <img
                  src="../../assets/img/home/brandCollect/img/box3_icon1.png"
                  alt=""
                  class="icon"
                  v-else
                />
                <div class="title">
                  {{ translateTitle("Empower 扶摇直上") }}
                </div>
                <div class="text">
                  {{ translateTitle("4E致力赋能用户，掌握人生财富主权") }}
                </div>
              </div>
              <div class="item2 item">
                <img
                  src="../../assets/img/home/brandCollect/img/dark_box3_icon3.png"
                  alt=""
                  class="icon"
                  v-if="isdark"
                />
                <img
                  src="../../assets/img/home/brandCollect/img/box3_icon3.png"
                  alt=""
                  class="icon"
                  v-else
                />
                <div class="title">{{ translateTitle("Evolve 与时俱进") }}</div>
                <div class="text">
                  {{ translateTitle("4E紧握时代脉搏，引领全球交易新风向") }}
                </div>
              </div>
            </div>
            <div class="rightBox">
              <div class="item3 item">
                <img
                  src="../../assets/img/home/brandCollect/img/dark_box3_icon2.png"
                  alt=""
                  class="icon"
                  v-if="isdark"
                />
                <img
                  src="../../assets/img/home/brandCollect/img/box3_icon2.png"
                  alt=""
                  class="icon"
                  v-else
                />
                <div class="title">{{ translateTitle("Enrich 锦上添花") }}</div>

                <div class="text">
                  {{ translateTitle("4E专注用户体验，创造更多价值与满足") }}
                </div>
              </div>
              <div class="item4 item">
                <img
                  src="../../assets/img/home/brandCollect/img/dark_box3_icon4.png"
                  alt=""
                  class="icon"
                  v-if="isdark"
                />
                <img
                  src="../../assets/img/home/brandCollect/img/box3_icon4.png"
                  alt=""
                  class="icon"
                  v-else
                />
                <div class="title">
                  {{ translateTitle("Exchange 携手共赢") }}
                </div>
                <div class="text">
                  {{ translateTitle("4E促进交流合作，与用户共享经验资源") }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import commonMixin from "@/components/common/commonMixin.vue";
import routeSplicing from "@/assets/js/routeSplicing";
import { mapGetters } from "vuex";
export default {
  props: {},
  components: {},
  mixins: [commonMixin],
  data() {
    return {
      colorModel: 1,
      activeBox3: 1,
      playing: false,
      mySwiper: null,
      // isdark: false,
      bannerNum: 1,
    };
  },
  async created() {},
  destroyed() {},
  beforeDestroy() {},
  watch: {},
  computed: {
    ...mapGetters({
      language: "user/language",
    }),
    isdark() {
      return this.isDarkMode;
    },
  },
  mounted() {
    setTimeout(() => {
      this.initSwiper();
    });
  },
  methods: {
    routeSplicing,
    updateZIndex(swiper) {
      let slides = swiper.slides;
      slides.forEach((slide, index) => {
        slide.style.zIndex = slides.length - Math.abs(swiper.realIndex - index);
        // slide.style.transform = `translateX(${-(index * 600)}px)`
        if (swiper.realIndex === index) {
          slide.style.transform = `translateX(${-(index * 600)}px)`;
        } else {
          if (swiper.realIndex === 1) {
            slides[0].style.transform = `translateX(60px)`;
            slides[0].style.zIndex = 1;
            slides[2].style.transform = `translateX(-1180px)`;
            slides[2].style.zIndex = 3;
            slides[3].style.transform = `translateX(-1760px)`;
            slides[3].style.zIndex = 2;
          } else if (swiper.realIndex === 2) {
            slides[0].style.transform = `translateX(40px)`;
            slides[0].style.zIndex = 2;
            slides[1].style.transform = `translateX(-540px)`;
            slides[1].style.zIndex = 1;
            slides[3].style.transform = `translateX(-1780px)`;
            slides[3].style.zIndex = 3;
          } else if (swiper.realIndex === 3) {
            slides[0].style.transform = `translateX(20px)`;
            slides[0].style.zIndex = "3";
            slides[1].style.transform = `translateX(-560px)`;
            slides[1].style.zIndex = "2";
            slides[2].style.transform = `translateX(-1140px)`;
            slides[2].style.zIndex = "1";
          }
        }
      });
    },
    initSwiper() {
      let This = this;
      this.mySwiper = new Swiper(".swiper", {
        effect: "cards",
        loop: false,
        cardsEffect: {
          slideShadows: false,
          perSlideRotate: 0,
          perSlideOffset: 6,
        },
        on: {
          init: function (swiper) {
            // let slides = swiper.slides;
            // setTimeout(()=> {
            //   slides.forEach((slide, index) => {
            //     if (index !== 0) slide.style.transform = `translateX(${-index*600 + index*40}px)`
            //   })
            // },100)
          },
          slideChange: function () {
            let isLastSlide = this.isEnd;
            this.allowSlideNext = !isLastSlide;
            This.bannerNum = this.activeIndex + 1;
            This.updateZIndex(this);
          },
          touchEnd: function (swiper) {
            This.updateZIndex(this);
          },
          touchStart: function () {
            let isLastSlide = this.isEnd;
            this.allowSlideNext = !isLastSlide;
          },
        },
      });
    },
    goBackUrl() {
      if (this.bannerNum === 1) {
        window.open("https://x.com/Click_Web3/status/1882414435417067529");
      } else if (this.bannerNum === 2) {
        window.open("https://x.com/4E_Global/status/1894705183101169954");
      } else if (this.bannerNum === 3) {
        window.open("https://x.com/4E_Global/status/1903795801635356894");
      } else if (this.bannerNum === 4) {
        window.open("https://x.com/4echinese/status/1901573749000020388?s=46");
      }
    },
    goPre() {
      if (this.bannerNum !== 1) {
        this.bannerNum--;
        this.mySwiper.slidePrev();
      }
    },
    goNext() {
      if (this.bannerNum !== 4) {
        this.bannerNum++;
        this.mySwiper.slideNext();
      }
    },
    getName() {
      if (this.isdark) {
        return "dark";
      } else {
        return "light";
      }
    },
    goBannerPre() {
      this.mySwiper.slidePrev();
    },
    goBannerNext() {
      this.mySwiper.slideNext();
    },
    checkMatchMedia() {
      if (
        window.matchMedia &&
        window.matchMedia("(prefers-color-scheme: dark)").matches
      ) {
        // 暗黑模式
        this.colorModel = 1;
        document.querySelector("html").setAttribute("theme", "dark");
        document.getElementById("mApp").classList.add("dark");
        this.isdark = true;
      } else {
        // 明亮模式
        this.colorModel = 2;
        document.querySelector("html").setAttribute("theme", "light");
        document.getElementById("mApp").classList.remove("dark");
        this.isdark = false;
      }
    },
    setLang() {
      let lang = (navigator.browserLanuage || navigator.language).toLowerCase();
      this.language =
        lang.indexOf("vi") > -1 ? "vi" : lang.indexOf("en") > -1 ? "en" : "zh";
    },
    setRem() {
      var clientWidth = document.documentElement.clientWidth;
      var rem = (clientWidth / 375) * 100; // 375是设计稿宽度，10是基准字体大小
      document.documentElement.style.fontSize = rem + "px";
    },
    back() {
      window.open("http://www.eeee.com");
    },
    // translateTitle(key, isBreak = false) {
    //   return langMap[this.language][key];
    // },

    goPage(url) {
      window.open(url);
    },
    goUrl(type) {
      let url = "";
      switch (type) {
        case "discord":
          url = "https://discord.com/invite/67573MsyZc";
          break;
        case "linkedIn":
          url = "https://www.linkedin.cn/incareer/company/4e-exchange/";
          break;
        case "instagram":
          url = "https://www.instagram.com/global_4e/";
          break;
        case "telegram":
          url = "https://t.me/Official_4e";
          break;
        case "twitter":
          url = "https://twitter.com/4e_Global";
          break;
        case "zalo":
          url = "https://zalo.me/g/lxmdpj687";
          break;
      }
      window.open(url);
    },
    playVideo() {
      this.playing = true;
      setTimeout(() => {
        const videoDom = document.querySelector(".videoBox");
        videoDom.play();
      }, 50);
      // window.open("https://drive.google.com/file/d/1HzoJ-PeokUZkFxHO-NtiqJatW12E_Mgp/view?usp=sharing");
    },
    goRegister() {
      window.open("https://www.eeee.com/register");
    },
    goMore() {
      window.open("https://www.eeee.com/markets");
    },
    overItem(index) {
      this.activeBox3 = index;
    },
  },
};
</script>
<style lang="scss">
#app {
  background: #fff;
}
#app:not(.zh_CN, .zh_HK) {
  .xianchang {
    margin-left: 8px;
  }
  .brand-collect .pcWrap .box1 .innerBox .list .item .text2 {
    font-size: 48px;
  }
  .brand-collect .pcWrap .box1 .innerBox .list .item .text2 i {
    font-size: 18px;
    position: relative;
    top: -8px;
  }
  .brand-collect .pcWrap .box1 .innerBox .list {
    gap: 12px;
    padding: 36px 20px;
  }
  .brand-collect .pcWrap .box1 .innerBox .list .item .text1 {
    font-size: 18px;
  }
  .brand-collect .pcWrap .topBox .innerBox .leftBox {
    max-width: 600px;
  }
  .brand-collect .pcWrap .box3 .innerBox > div .item {
    height: auto;
    min-height: 250px;
  }
  .brand-collect .pcWrap .box3 {
    margin-bottom: 40px;
  }
  .brand-collect .pcWrap .box1 .innerBox .list .item {
    &:nth-child(1) {
      flex: 1.5;
    }
    &:nth-child(2) {
      flex: 1.2;
    }
    &:nth-child(4) {
      flex: 1.2;
    }
  }
}
:root[theme="dark"] {
  .brand-collect {
    background: #000;
    .pcWrap .box3 .innerBox > div .item .title {
      color: #fff;
    }
    .pcWrap .box3 .innerBox > div .item .text {
      color: rgba(255, 255, 255, 0.65);
    }
    .pcWrap .topBox {
      background: url("../../assets/img/home/brandCollect/img/dark_top_bg.png")
          no-repeat bottom center,
        #000;
      background-size: auto 654px;
    }
    .pcWrap .topBox .innerBox .leftBox .title1 {
      background: linear-gradient(246deg, #3348f6 16.47%, #fff 80.68%);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    .pcWrap .topBox .innerBox .leftBox .title2 {
      color: #fff;
    }
    .pcWrap .topBox .innerBox .leftBox .text {
      color: #fff;
    }
    .pcWrap .topBox .innerBox .leftBox .btns .icon {
      width: 60px;
      height: 60px;
      margin-right: 12px;
    }
    .pcWrap .box1 .innerBox .title {
      color: #fff;
    }
    .pcWrap .box1 .innerBox .subTitle {
      color: #fff;
    }
    .pcWrap .box2 .titleBox span {
      color: #fff;
    }
    .pcWrap .box2 .titleBox span i {
      background: linear-gradient(94deg, #3348f6 50.96%, #fff 83.81%);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    .pcWrap .box2 .contentBox {
      background: url("../../assets/img/home/brandCollect/img/dark_box2_bg.png")
        no-repeat center;
      background-size: auto 2047px;
    }
    .pcWrap .box2 .contentBox .item1 {
      background: url("../../assets/img/home/brandCollect/img/dark_right_item_bg.png")
          no-repeat,
        #141414;
      background-size: 100% 100%;
    }
    .pcWrap .box2 .contentBox .item1 .textBox .icon {
      border: 1px solid rgba(238, 238, 238, 0.4);
    }
    .pcWrap .box2 .contentBox .item1 .textBox .icon-text {
      color: #fff;
    }
    .pcWrap .box2 .contentBox .item1 .textBox .text {
      color: #fff;
    }
    .pcWrap .box2 .contentBox .item1 .textBox .tips {
      color: #fff;
    }
    .pcWrap .box2 .contentBox .item2 {
      background: url("../../assets/img/home/brandCollect/img/dark_left_item_bg.png")
          no-repeat center right,
        #3348f6;
      background-size: contain;
    }
    .pcWrap .box3 {
      background: url("../../assets/img/home/brandCollect/img/dark_box3_bg.png")
        no-repeat center;
      background-size: auto 100%;
    }
    .pcWrap .box3 .innerBox > div .item {
      border-radius: 16px;
      border: 1px solid #353437;
      background: #141414;
    }
    .pcWrap .box3 .innerBox > div .item {
      /* background: url("../../assets/img/home/brandCollect/img/dark_box3_item_bg2.png")
        no-repeat center; */
      /* background-size: 100% 100%; */
    }
    .pcWrap .box3 .innerBox > div .item:hover {
      /* border: 1px solid #475bff;
      background: url("../../assets/img/home/brandCollect/img/dark_box3_item_bg1.png")
          no-repeat center,
        #141414; */
      border: 1px solid var(--Dark04-text-c_m, #1745f0);
      /* background: linear-gradient(
        131deg,
        rgba(74, 202, 250, 0.08) 0%,
        rgba(236, 54, 235, 0.08) 100%
      ); */
      background-size: 100% 100%;
    }
    .pcWrap .topBox .innerBox .rightBox .others .btns span {
      color: #fff;
    }
  }
}
.brand-collect {
  .wrap {
    position: relative;
    margin: auto;
    display: flex;
    flex-direction: column;
    font-family: "Open Sans", "SanFranciso display";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
  }

  /* PC */
  .pcWrap {
    min-width: 1200px;
    /* padding:0 20px; */
    box-sizing: border-box;
  }

  .pcWrap .body {
    position: relative;
  }

  .pcWrap .topBox {
    position: relative;
    min-width: 1200px;
    height: 654px;
    background: url("../../assets/img/home/brandCollect/img/light_top_bg.png")
        no-repeat bottom center,
      #fff;
    background-size: auto 654px;
  }
  .pcWrap .topBox .innerBox {
    width: 1200px;
    padding-top: 110px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
  }
  .pcWrap .topBox .innerBox .leftBox {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  .pcWrap .topBox .innerBox .leftBox .title1 {
    position: relative;
    font-size: 50px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    background: linear-gradient(246deg, #3348f6 16.47%, #0a1046 80.68%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .pcWrap .topBox .innerBox .leftBox .title1::after {
    position: absolute;
    content: "";
    right: -55px;
    top: 0;
    width: 55px;
    height: 52px;
    background: url("../../assets/img/home/brandCollect/img/top_tag.png")
      no-repeat;
    background-size: 100% 100%;
  }
  .pcWrap .topBox .innerBox .leftBox .title2 {
    color: #000;
    font-size: 50px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin-bottom: 12px;
  }

  .pcWrap .topBox .innerBox .leftBox .text {
    color: rgba(0, 0, 0, 0.65);
    font-size: 28px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-bottom: 83px;
  }

  .pcWrap .topBox .innerBox .leftBox .btns {
    display: flex;
    align-items: center;
  }
  .pcWrap .topBox .innerBox .leftBox .btns .btn {
    display: flex;
    min-width: 168px;
    height: 60px;
    padding: 0px 16px;
    justify-content: center;
    align-items: center;
    gap: 4px;
    flex-shrink: 0;
    border-radius: 200px;
    background: linear-gradient(90deg, #2232b8 0%, #3348f6 100%),
      rgba(0, 255, 251, 0.1);
    margin-right: 16px;
    cursor: pointer;
  }
  .pcWrap .topBox .innerBox .leftBox .btns .btn span {
    color: var(--7-c_i_bg, #f7f8fa);
    font-family: "PingFang SC";
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 21px; /* 131.25% */
  }
  .pcWrap .topBox .innerBox .leftBox .btns .icon {
    width: 80px;
    height: 80px;
    cursor: pointer;
  }
  .pcWrap .topBox .innerBox .rightBox {
    position: relative;
    width: 600px;
    overflow: hidden;
  }
  .pcWrap .topBox .innerBox .rightBox .swiper {
    width: 600px;
  }
  .pcWrap .topBox .innerBox .rightBox .swiper .swiper-wrapper {
    width: 600px;
    height: 305px;
  }
  .pcWrap
    .topBox
    .innerBox
    .rightBox
    .swiper-wrapper
    .swiper-wrapper
    .swiper-slide {
    width: 524px;
    height: 305px;
  }
  .pcWrap
    .topBox
    .innerBox
    .rightBox
    .swiper
    .swiper-wrapper
    .swiper-slide
    img {
    width: 524px;
    height: 100%;
  }
  .pcWrap .topBox .innerBox .rightBox .others {
    display: flex;
    justify-content: space-between;
    margin-top: 17px;
  }
  .pcWrap .topBox .innerBox .rightBox .others .history {
    color: #959bcd;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    cursor: pointer;
  }
  .pcWrap .topBox .innerBox .rightBox .others .btns {
    display: flex;
    align-items: center;
  }
  .pcWrap .topBox .innerBox .rightBox .others .btns .leftIcon,
  .pcWrap .topBox .innerBox .rightBox .others .btns .rightIcon {
    width: 32px;
    height: 32px;
    cursor: pointer;
  }
  .pcWrap .topBox .innerBox .rightBox .others .btns span {
    color: #000;
    font-family: "DIN Condensed";
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 21px; /* 105% */
    margin: 0 18px;
  }

  /* box1 */
  .pcWrap .box1 {
    margin-bottom: 120px;
  }
  .pcWrap .box1 .innerBox {
    width: 1200px;
    margin: 0 auto;
  }
  .pcWrap .box1 .innerBox .title {
    color: #000;
    text-align: center;
    font-size: 40px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin-bottom: 20px;
  }

  .pcWrap .box1 .innerBox .title span {
    background: linear-gradient(94deg, #3348f6 50.96%, #0c1663 83.81%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  .pcWrap .box1 .innerBox .subTitle {
    color: rgba(0, 0, 0, 0.65);
    text-align: center;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px; /* 90% */
    margin-bottom: 44px;
  }

  .pcWrap .box1 .innerBox .list {
    width: 1200px;
    min-height: 240px;
    background: url("../../assets/img/home/brandCollect/img/box1_bg.png")
      no-repeat center;
    background-size: 100% 100%;
    padding: 36px 44px;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
  }
  .pcWrap .box1 .innerBox .list .item {
    display: flex;
    flex-direction: column;
    flex: 1;
  }
  .pcWrap .box1 .innerBox .list .item .text1 {
    color: rgba(255, 255, 255, 0.85);
    margin-bottom: 16px;
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
  .pcWrap .box1 .innerBox .list .item .text2 {
    color: #fff;
    font-size: 66px;
    font-style: normal;
    font-weight: 600;
    line-height: 66px;
    display: flex;
    align-items: flex-end;
    margin: 10px 0 12px;
  }
  .pcWrap .box1 .innerBox .list .item .text2 i {
    font-size: 24px;
    line-height: normal;
    font-style: normal;
  }
  .pcWrap .box1 .innerBox .list .item .text3 {
    color: rgba(255, 255, 255, 0.65);
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  /* box2 */
  .pcWrap .box2 .titleBox {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 33px;
  }
  .pcWrap .box2 .titleBox span {
    color: #000;
    text-align: center;
    font-size: 40px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin: 0 30px;
  }

  .pcWrap .box2 .titleBox .titleTag {
    height: 60px;
  }
  .pcWrap .box2 .titleBox span i {
    font-style: normal;
    background: linear-gradient(94deg, #3348f6 50.96%, #0c1663 83.81%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-size: 40px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }

  .pcWrap .box2 .contentBox {
    width: 100%;
    min-width: 1200px;
    height: 2047px;
    background: url("../../assets/img/home/brandCollect/img/box2_bg.png")
      no-repeat center;
    /* background: url("../../assets/img/home/brandCollect/img/box2_bg.png") no-repeat center; */
    background-size: auto 2047px;
    display: flex;
    flex-direction: column;
  }

  .pcWrap .box2 .contentBox .item {
    display: flex;
    justify-content: space-between;
    border-radius: 20px;
    margin-bottom: 50px;
  }
  .pcWrap .box2 .contentBox .item1 {
    /* width: 1560px; */
    height: 600px;
    filter: drop-shadow(0px 4px 20px rgba(0, 0, 0, 0.1));
    background: url("../../assets/img/home/brandCollect/img/right_item_bg.png")
        no-repeat,
      #fff;
    background-size: 100% 100%;
    align-self: flex-end;
  }

  .pcWrap .box2 .contentBox .item1 .textBox {
    padding: 50px 0 0 44px;
    display: flex;
    flex-direction: column;
  }
  .pcWrap .box2 .contentBox .item1 .textBox .icon {
    width: fit-content;
    min-width: 144px;
    height: 40px;
    margin-bottom: 36px;
    border-radius: 100px;
    display: flex;
    align-items: center;
    padding: 0 6px;
    box-sizing: border-box;
    border: 1px solid #eee;
  }

  .pcWrap .box2 .contentBox .item1 .textBox .icon-img {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    padding: 6px;
    background: rgba(51, 72, 246, 0.07);
  }
  .pcWrap .box2 .contentBox .item1 .textBox .icon-text {
    color: #3348f6;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    margin-left: 13px;
  }
  .pcWrap .box2 .contentBox .item1 .textBox .text {
    color: #000;
    font-size: 50px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin-bottom: 36px;
    min-width: 490px;
    max-width: 490px;
    margin-right: 32px;
  }

  .pcWrap .box2 .contentBox .item1 .textBox .tips {
    color: rgba(0, 0, 0, 0.65);
    font-family: "Open Sans";
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  .pcWrap .box2 .contentBox .item1 .img {
    width: auto;
    height: 100%;
    border-radius: 20px 0 0 20px;
  }
  .pcWrap .box2 .contentBox .item2 {
    /* width: 1560px; */
    height: 600px;
    filter: drop-shadow(0px 4px 20px rgba(0, 0, 0, 0.1));
    background: url("../../assets/img/home/brandCollect/img/left_item_bg.png")
        no-repeat center right,
      #3348f6;
    background-size: contain;
    align-self: flex-start;
  }

  .pcWrap .box2 .contentBox .item2 .img {
    width: auto;
    height: 100%;
    border-radius: 0 20px 20px 0;
  }
  .pcWrap .box2 .contentBox .item2 .textBox {
    padding: 50px 44px 0 0;
    display: flex;
    width: 413px;
    flex-direction: column;
    align-items: flex-end;

    &.text-box-2 {
      margin-left: 143px;
    }
  }
  .pcWrap .box2 .contentBox .item2 .textBox .icon {
    width: fit-content;
    min-width: 144px;
    height: 40px;
    margin-bottom: 36px;
    border-radius: 100px;
    display: flex;
    align-items: center;
    padding: 0 6px;
    box-sizing: border-box;
    border: 1px solid rgba(238, 238, 238, 0.4);
    backdrop-filter: blur(2px);
  }
  .pcWrap .box2 .contentBox .item2 .textBox .icon-img {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
  }
  .pcWrap .box2 .contentBox .item2 .textBox .icon-text {
    color: #fff;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    margin-left: 10px;
  }

  .pcWrap .box2 .contentBox .item2 .textBox .text {
    color: #fff;
    text-align: right;
    font-size: 50px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin-bottom: 36px;
  }
  .pcWrap .box2 .contentBox .item2 .textBox .tips {
    color: #fff;
    text-align: right;
    font-family: "Open Sans";
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px; /* 75% */
  }

  /* box3 */
  .pcWrap .box3 {
    width: 100%;
    min-width: 1200px;
    margin: 0 auto;
    min-height: 800px;
    background: url("../../assets/img/home/brandCollect/img/box3_bg.png")
      no-repeat center;
    background-size: auto 100%;
    box-sizing: border-box;
  }

  .pcWrap .box3 .innerBox {
    width: 1200px;
    padding-top: 128px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
  }
  .pcWrap .box3 .innerBox > .leftBox,
  .pcWrap .box3 .innerBox > .rightBox {
    display: flex;
    flex-direction: column;
    /* > .item1,
    > .item2 {
      height: 50%;
    } */
    > .item2,
    > .item4 {
      flex: 1;
    }
  }
  .pcWrap .box3 .innerBox > div .item {
    position: relative;
    width: 300px;
    height: 250px;
    padding: 40px 15px 40px 20px;
    border-radius: 16px;
    border: 1px solid #ececf1;
    background: rgba(255, 255, 255, 0.9);
    backdrop-filter: blur(2px);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    /* flex-direction: column-reverse; */
  }

  .pcWrap .box3 .innerBox > div .item .title {
    color: #000;
    font-family: "Open Sans";
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    margin-bottom: 12px;
  }

  .pcWrap .box3 .innerBox > div .item .text {
    color: rgba(0, 0, 0, 0.65);
    font-family: "Open Sans";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  .pcWrap .box3 .innerBox > div .item .icon {
    /* position: absolute; */
    width: 94px;
    /* height: 94px; */
    /* top: 20px;
    left: 20px; */
  }

  .pcWrap .box3 .innerBox > div .item1 {
    margin-bottom: 35px;
  }

  .pcWrap .box3 .innerBox > div .item3 {
    margin-bottom: 35px;
  }
  .pcWrap .box3 .innerBox > div .item {
    /* background: url("../../assets/img/home/brandCollect/img/box3_item_bg2.png")
      no-repeat center;
    background-size: 100% 100%; */
  }
  .pcWrap .box3 .innerBox > div .item:hover {
    /* border: 1px solid #475bff;
    background: url("../../assets/img/home/brandCollect/img/box3_item_bg1.png")
        no-repeat center,
      #fff; */
    border: 1px solid var(--Dark04-text-c_m, #1745f0);
    /* background: linear-gradient(
      131deg,
      rgba(74, 202, 250, 0.08),
      rgba(236, 54, 235, 0.08)
    ); */
    background-size: 100% 100%;
  }

  .popupWrap {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 999;
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.502);
    align-items: end;
  }

  .popupWrap .popupBox {
    position: relative;
    padding: 16px;
    width: 100%;
    max-height: calc(100% - 100px);
    border-radius: 12px 12px 0 0;
    display: flex;
    flex-direction: column;
    background: #fff;
  }
  .popupWrap .popupBox .popupTitle {
    font-size: 18px;
    font-weight: 500;
    color: #000;
  }
  .popupWrap .popupBox .ruleBox {
    margin: 16px 0;
    flex: 1;
    overflow: auto;
    font-size: 16px;
    line-height: 21px;
  }
  .popupWrap .popupBox .ruleBox .ruleItem {
    font-size: 16px;
    line-height: 21px;
    color: #000;
  }
  .popupWrap .popupBox .ruleBox .ruleItem:not(last-child) {
    margin-bottom: 12px;
  }
  .popupWrap .popupBox .btn {
    width: 100%;
    height: 44px;
    line-height: 44px;
    border-radius: 22px;
    font-size: 18px;
    text-align: center;
    cursor: pointer;
    font-weight: 700;
    background-color: #3348f6;
    color: #fff;
  }
  .popupWrap .popupBox .closeIcon {
    position: absolute;
    top: 20px;
    right: 20px;
  }
  .popupWrap .popupBox .closeIcon img {
    width: 14px;
    height: 14px;
  }

  .fixedFooter {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 20px;
    display: flex;
    align-items: center;
    background: #fff;
    z-index: 1;
  }
  .service {
    display: flex;
    width: 44px;
    height: 44px;
    border-radius: 50%;
    cursor: pointer;
  }
  .mWrap .service2 {
    margin: 0 8px;
  }
  .mWrap .joinBtn {
    flex: 1.5;
  }
  .fixedFooter .btn {
    height: 44px;
    line-height: 44px;
    border-radius: 42px;
    font-size: 18px;
    text-align: center;
    cursor: pointer;
    font-weight: 700;
    background-color: #3348f6;
    color: #fff;
  }
}
@keyframes spin {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
